import Divider from "@mui/material/Divider";
import {Drawer, ListItemButton, ListItemText, Tooltip} from "@mui/material";
import * as React from "react";
import {MAIN_MENU_WIDTH} from "../../../../Config/MenuUtil";
import DrawerHeader from "./DrawerHeader";
import {Link, useLocation} from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCircleQuestion,
    faFileLines,
    faGear,
    faHome,
    faRightLeft,
    faMagnifyingGlass,
    faTicketSimple
} from "@fortawesome/free-solid-svg-icons";
import List from "@mui/material/List";
import {toggleMainMenu, toggleSubMenu} from "../../../../Config/Reducers/LayoutReducer";
import {useAppDispatch, useAppSelector} from "../../../../Config/Hooks";
import {SystemRoutes} from "../../../../Utils/RouteUtils";
import { AUTHORITIES } from "../../../../Config/Constants";
import { hasPermission } from "../../../Auth/AuthenticationUtil";
import { getFirstAccessibleSettingsRoute, hasAnySettingsAccess } from "../../../../Utils/SettingsRouteUtils";

const style = {
    logo: {
        marginLeft: 17,
        height: 40,
        width: 'auto'
    },
    linkItem: {
        textDecoration: "none",
        color: "inherit"
    },
    listItem: {
        padding: 0,
        backgroundColor: "none",
    },
    listItemText: {
        textAlign: "center",
        color: "#747474",
        fontSize: 22
    },
    iconSize: {
        fontSize: 22
    }
};

export default function SGDMainMenu () {
    const isAuthenticated = useAppSelector((state: any) => state.authentication.isAuthenticated);

    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToDashboard = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD, AUTHORITIES.VIEW_DASHBOARD_CHART
    ]);

    const isAuthorizedToAnalysis = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_ANALYSIS, AUTHORITIES.SEARCH_ANALYSIS, AUTHORITIES.SAVE_ANALYSIS
    ]);
    const isAuthorizedToCommunication = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN,
        AUTHORITIES.VIEW_COMMAND_HISTORY,
        AUTHORITIES.VIEW_TELEOBJECT_INHIBITION
    ]);
    const communicationRoute = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN,
        AUTHORITIES.VIEW_COMMAND_HISTORY
    ])
        ? SystemRoutes.COMMUNICATION_SENT_TELECOMMAND
        : SystemRoutes.COMMUNICATION_TELEOBJECTS;
    const isAuthorizedToSetting = hasAnySettingsAccess(account?.authoritySet ?? []);
    const isAuthorizedToReport = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_REPORT
    ]);

    const isAuthorizedToAudit = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_AUDIT
    ]);

    const isAuthorizedToTickets = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_TICKET
    ]);

    const openMainMenu = useAppSelector((state: any) => state.layout.openMainMenu);
    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);
    const location = useLocation();
    const dispatch = useAppDispatch();

    const toggle = () => {
        dispatch(toggleMainMenu());
        dispatch(toggleSubMenu());
    }

    const closeSubMenu = () => {
        if (openSubMenu) dispatch(toggleSubMenu());
    }

    if(isAuthenticated )return (
        <Drawer
            variant="persistent"
            sx={{
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: MAIN_MENU_WIDTH, height: '100vh' },
            }}
            open={openMainMenu}
            onClose={toggle}
        >
            <DrawerHeader />
            <List>
                <Link style={style.linkItem} to={isAuthorizedToDashboard ? "/dashboard/overview" : "#"}>
                    <ListItem style={style.listItem} selected={location.pathname.includes("dashboard")}>
                        <Tooltip title="Dashboard" placement="left" arrow>
                            <ListItemButton sx={style.listItemText} disabled={!isAuthorizedToDashboard}>
                                <ListItemText>
                                    <FontAwesomeIcon icon={faHome} style={style.iconSize}/>
                                </ListItemText>
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                </Link>
                <Divider component="li" />
                <Link style={style.linkItem} to={isAuthorizedToAnalysis ? SystemRoutes.ANALYSIS : "#"}>
                    <ListItem style={style.listItem} selected={location.pathname.includes("analysis")}>
                        <Tooltip title="Analysis" placement="left" arrow>
                            <ListItemButton sx={style.listItemText} disabled={!isAuthorizedToAnalysis}>
                                <ListItemText>
                                    <FontAwesomeIcon icon="chart-line" style={style.iconSize}/>
                                </ListItemText>
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                </Link>
                <Divider component="li" />
                <Link style={style.linkItem} to={isAuthorizedToCommunication ? communicationRoute : "#"}>
                    <ListItem style={style.listItem} selected={location.pathname.includes("communication")}>
                        <Tooltip title="Comunication" placement="left" arrow>
                            <ListItemButton sx={style.listItemText} disabled={!isAuthorizedToCommunication}>
                                <ListItemText>
                                    <FontAwesomeIcon icon={faRightLeft} style={style.iconSize}/>
                                </ListItemText>
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                </Link>
                <Divider component="li" />
                <Link style={style.linkItem} to={isAuthorizedToSetting ? getFirstAccessibleSettingsRoute(account?.authoritySet ?? []) : "#"} >
                    <ListItem style={style.listItem} selected={location.pathname.includes("settings")}>
                        <Tooltip title="Settings" placement="left" arrow>
                            <ListItemButton sx={style.listItemText} disabled={!isAuthorizedToSetting}>
                                <ListItemText>
                                    <FontAwesomeIcon icon={faGear} style={style.iconSize}/>
                                </ListItemText>
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                </Link>
                <Divider component="li" />
                <Link style={style.linkItem} to={isAuthorizedToReport ? SystemRoutes.REPORTS_TELEOBJECTS : '#'}>
                    <ListItem style={style.listItem} selected={location.pathname.includes("reports")}>
                        <Tooltip title="Reports" placement="left" arrow>
                            <ListItemButton sx={style.listItemText} disabled={!isAuthorizedToReport}>
                                <ListItemText>
                                    <FontAwesomeIcon icon={faFileLines} style={style.iconSize}/>
                                </ListItemText>
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                </Link>
                <Divider component="li" />
                <Link style={style.linkItem} to={isAuthorizedToTickets ? SystemRoutes.SETTINGS_TICKET : '#'} onClick={closeSubMenu}>
                    <ListItem style={style.listItem} selected={location.pathname.includes("ticket")}>
                        <Tooltip title="Tickets" placement="left" arrow>
                            <ListItemButton sx={style.listItemText} disabled={!isAuthorizedToTickets}>
                                <ListItemText>
                                    <FontAwesomeIcon icon={faTicketSimple} style={style.iconSize}/>
                                </ListItemText>
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                </Link>
                <Divider component="li" />
                <Link style={style.linkItem} to={isAuthorizedToAudit ? SystemRoutes.AUDIT_COMMANDS : '#'}>
                    <ListItem style={style.listItem} selected={location.pathname.includes("audit")}>
                        <Tooltip title="Audit" placement="left" arrow>
                            <ListItemButton sx={style.listItemText} disabled={!isAuthorizedToAudit}>
                                <ListItemText>
                                    <FontAwesomeIcon icon={faMagnifyingGlass} style={style.iconSize}/>
                                </ListItemText>
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                </Link>
                <Divider component="li" />
                {/*<Link style={style.linkItem} to="/help">*/}
                <Link aria-disabled={true} style={style.linkItem} to="#">
                    <ListItem style={style.listItem} selected={location.pathname.includes("help")}>
                        <Tooltip title="Help" placement="left" arrow>
                            <ListItemButton disabled sx={style.listItemText}>
                                <ListItemText>
                                    <FontAwesomeIcon icon={faCircleQuestion} style={style.iconSize}/>
                                </ListItemText>
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                </Link>
            </List>
        </Drawer>
    );

    return null;
};
